export default __webpack_public_path__ + "media/images/noukaweb-logo.2d449282a9ff902fec7640e7fd904a28.webp";